import { AssetStatus, useGetGoodProfileListQuery } from "../../../graphql/generated";
import GoodProfileSelect, {
  MultiSelectGoodProfileProps,
  SingleSelectGoodProfileProps,
} from "./GoodProfileSelect";

type GoodProfileSelectContainerProps =
  | Omit<SingleSelectGoodProfileProps, "goodProfiles" | "onGoodProfilesRefetch">
  | Omit<MultiSelectGoodProfileProps, "goodProfiles" | "onGoodProfilesRefetch">;

const GoodProfileSelectContainer = (props: GoodProfileSelectContainerProps) => {
  const goodProfilesQuery = useGetGoodProfileListQuery({ includeInactive: true });

  const selectedIds = Array.isArray(props.value)
    ? props.value
    : props.value
    ? [props.value]
    : [];
  const goodProfiles = (goodProfilesQuery.data?.goodProfiles.data || []).filter(
    (profile) =>
      profile.status !== AssetStatus.Inactive || selectedIds.includes(profile._id)
  );

  return (
    <GoodProfileSelect
      {...props}
      goodProfiles={goodProfiles}
      onGoodProfilesRefetch={async () => {
        await goodProfilesQuery.refetch();
      }}
    />
  );
};

export default GoodProfileSelectContainer;
